import React from 'react'
import "../../styles/ComponentsStyles/Universal/ScrollableShortCard.style.css"
import CardHeader from './CardHeader.component'
import PropTypes from 'prop-types'
const ScrollableShortCard = ({ title, actionBtn, children, scrollableCardsStyle, scrollableCardsParentStyle }) => {
    return (
        <div className="scrollableShortCardParent">
            <CardHeader title={title} actionBtn={actionBtn} />
            <div className="scrollableShortCardDataContainer" style={scrollableCardsParentStyle}>
                <ul style={scrollableCardsStyle}>
                    {children}
                </ul>
            </div>
        </div>
    )
}

export default ScrollableShortCard
ScrollableShortCard.propTypes = {
    title: PropTypes.string.isRequired,
    actionBtn: PropTypes.element,
    children: PropTypes.element.isRequired,
    scrollableCardsStyle: PropTypes.object,
    scrollableCardsParentStyle: PropTypes.object
}